interface Properties {
  onSubmit: (e: any) => void;
  action: string;
}

const Form: React.FC<Properties> = ({ ...props }) => {
  return <form className="mx-6 my-2" {...props} />;
};

export default Form;

export { default as InputField } from "./input-field";
export { default as SubmitButton } from "../../../components/submit-button";
